import React, {FunctionComponent, useContext, useEffect, useRef, useState} from 'react';
import MapContext from '../map/MapContext';
import {OverlayPanel} from 'primereact/overlaypanel';
import {useTranslation} from 'react-i18next';
import {Dropdown} from 'primereact/dropdown';
import {getSpatialBookmarks} from '../../functions/Global';
import {transformCoordinateArray, transformCoords} from '../../../services/SpatialService';

interface propsObj {
    [key: string]: any
}

type controlProps = {
    projectId: any
}
const BookmarkControl: FunctionComponent<controlProps> = (props) => {
    // @ts-ignore
    const {map} = useContext(MapContext);
    const {t} = useTranslation(['geomonitoring']);
    const op = useRef(null);
    const [selectPosition, setSelectedPosition] = useState({data: null});
    const [data, setData] = useState([]);
    const dataRef = useRef(data);
    const selectPositionRef = useRef(selectPosition);
    const [toogleAllowed, setToogleAllowed] = useState(false);
    const toogleRef = useRef(toogleAllowed);

    const createBaseMapButton = () => {
        const buttonBookmarkMap = document.createElement('button');
        buttonBookmarkMap.id = 'buttonBookmark';
        buttonBookmarkMap.title = t('bookmark');
        buttonBookmarkMap.innerHTML = '<span style="color: black"><i class="fas fa-bookmark"/></span>';
        buttonBookmarkMap.addEventListener('click', openDropdown, false);
        return buttonBookmarkMap;
    };

    const openDropdown = (e: any) => {
        // @ts-ignore
        op.current.toggle(e);
        toogleFnc(true);
    };

    const toogleFnc = (val: boolean) => {
        setToogleAllowed(val);
        toogleRef.current = val;
    };

    const addControl = () => {

        const bookmarkElem = document.getElementById('buttonBookmark');
        if (bookmarkElem === null) {
            const buttonBookmarkMap = createBaseMapButton();
            const elementLegende = document.getElementById('olToolkitControls');
            elementLegende?.appendChild(buttonBookmarkMap);
        }
        return [bookmarkElem];
    };

    const prepareBookmark = (bookmark: { is_permalink: boolean; link: { name: any; }; id: any; }) => {
        if (!bookmark.is_permalink) {
            const bName = bookmark.link.name;
            const placeholderInt=1212121212121;
            let int = 0;
            let string = bName;
            if (bName && bName.includes(':')) {
                const splitted = bName.split(':');
                int = splitted[0];
                string = splitted.pop();
            }else{
                int=placeholderInt;
            }
            return {id: bookmark.id, name: bName, data: bookmark, intSort: parseInt(String(int)), stringSort: string, numericalSort:int==placeholderInt?false:true};
        }
        return null;
    };

    const sortBookmark = (bookmarkArray: any) => {
        const sortedData = bookmarkArray.sort((a: any, b: any) =>a.numericalSort?(a.intSort - b.intSort|| a.stringSort.localeCompare(b.stringSort)): a.stringSort.localeCompare(b.stringSort));
        setData(sortedData);
        dataRef.current = sortedData;
    };

    const getBookmarks = () => {
        getSpatialBookmarks(props.projectId).then((bookmarks: any) => {
            const bookmarkArray: any = [];
            bookmarks.forEach((bookmark: any) => {
                const adjustedBM = prepareBookmark(bookmark);
                if (adjustedBM !== null)
                    bookmarkArray.push(adjustedBM);
            });

            sortBookmark(bookmarkArray);
        });
    };

    const contextMenuListener = () => {
        map.getViewport().addEventListener('contextmenu', function (evt: { preventDefault: () => void; }) {
            if (toogleRef.current) {
                // @ts-ignore
                op.current.toggle({currentTarget: null});
                toogleFnc(false);
            }
        });
    };

    useEffect(() => {
        if (selectPosition && selectPosition.data) {
            const bookmarkData: propsObj = selectPosition.data;
            let coords = [bookmarkData.position_x, bookmarkData.position_y];
            const epsg = bookmarkData.epsg_code;
            if (epsg !== 3857) {
                coords = transformCoords(coords, epsg, 3857);
            }
            map.getView().setZoom(bookmarkData.zoom);
            map.getView().setCenter(coords);
        }

        selectPositionRef.current = selectPosition;
    }, [selectPosition]);

    useEffect(() => {
        if (!map || Object.keys(map).length === 0) return;
        const bookmarkControl = addControl();
        getBookmarks();
        contextMenuListener();
        return () => map.controls.remove(bookmarkControl);
    }, [map]);


    return (
        <OverlayPanel ref={op}>
            <Dropdown value={selectPosition} onChange={(e) => setSelectedPosition(e.value)}
                      options={data} optionLabel="name"
                      placeholder={t('bookmarkPlaceholder')} className="w-auto"/>
        </OverlayPanel>

    );
};

export default BookmarkControl;
